import localFont from "next/font/local";

export const plusJakartaSans = localFont({
  src: [
    {
      path: "./plus-jakarta-sans-v12-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./plus-jakarta-sans-v12-latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./plus-jakarta-sans-v12-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  display: "swap",
  variable: "--font-plus-jakarta-sans",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: "Arial",
});

export const fonts = {
  plusJakartaSans,
};
